import { render, staticRenderFns } from "./WorkflowZoomVisaBlock.vue?vue&type=template&id=22b74882&"
import script from "./WorkflowZoomVisaBlock.vue?vue&type=script&lang=js&"
export * from "./WorkflowZoomVisaBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports